module.exports = __webpack_public_path__ + "img/ic_file-certificate.f0584db4.png";